import { CategoryRepository } from './repositories/category'
import { CategoryService } from './services/category'

const categoryRepository = new CategoryRepository()
const categoryService = new CategoryService({ categoryRepository })

export { categoryService }
